export const extractHtmlTitle = html => {
    if (typeof html !== 'string') return '';

    const match = html.match(/<title[^>]*>([\s\S]*?)<\/title>/i);
    return match?.[1]?.trim() || '';
};

const injectParentTitleSyncScript = (html, title) => {
    if (typeof html !== 'string' || !title) {
        return html;
    }

    const syncScript = `<script>(function(){try{window.top.document.title=${JSON.stringify(title)};}catch(e){}})();</script>`;

    if (/<head[^>]*>/i.test(html)) {
        return html.replace(/<head([^>]*)>/i, `<head$1>${syncScript}`);
    }

    return `${syncScript}${html}`;
};

const normalizeHtmlSource = async htmlSource => {
    if (typeof htmlSource === 'string') {
        return htmlSource;
    }

    if (htmlSource instanceof Blob) {
        return await htmlSource.text();
    }

    return htmlSource;
};

export const createIframeReportBlobUrl = async htmlSource => {
    const normalizedHtml = await normalizeHtmlSource(htmlSource);
    const reportTitle = extractHtmlTitle(normalizedHtml);

    if (reportTitle && typeof document !== 'undefined') {
        document.title = reportTitle;
    }

    const htmlWithParentTitleSync = injectParentTitleSyncScript(normalizedHtml, reportTitle);
    const blob = new Blob([htmlWithParentTitleSync], { type: 'text/html' });

    return {
        blobUrl: URL.createObjectURL(blob),
        title: reportTitle
    };
};
